import { WithFeatures } from '@etrigan/feature-toggles'
import { isFeatureEnabled } from '@etrigan/feature-toggles-client'
import { useFeature } from '@news-mono/web-common'
import express from 'express'
import { debounce } from 'lodash'
import React, { useEffect, useRef } from 'react'
import { Logger } from 'typescript-log'
import { FallbackMessage } from '../FallbackMessage/FallbackMessage'
import { generateStatsWidgetHtml } from '../helpers/generateStateWidgetHtml'
import { postWidthToIframe } from '../helpers/postWidthToIframe'
import { OlympicWidgetWrap } from '../OlympicWidgetWrap/OlympicWidgetWrap'
import { StyledIframe } from '../OlympicWidgetWrap/OlympicWidgetWrap.styled'
import { StyledScheduleWrap } from './Schedule.styled'

export interface ScheduleProps {
    isFullSize: boolean
}
export const generateScheduleWidget = (): express.Handler => {
    return async (
        req: express.Request & { log: Logger } & WithFeatures,
        res,
    ) => {
        if (
            !isFeatureEnabled(req.features, 'the-west-tokyo') &&
            !isFeatureEnabled(req.features, 'perthnow-tokyo')
        ) {
            return res.status(404).send()
        }

        req.log.debug({ req }, `medal widget requested`)

        res.set({
            'Content-Type': 'text/html',
        })

        return res.send(
            generateStatsWidgetHtml({
                id: 'shs-oly-olympic-schedule',
                scriptId: 'oly-olympic-schedule',
            }),
        )
    }
}
export function Schedule(props: ScheduleProps) {
    const { isFullSize } = props
    const scheduleIframe = useRef<any>()
    const widgetWrap = useRef<any>()
    const offset = 30

    const fallbackIsActive = useFeature('tokyo-schedule-widget-fallback')
    const fallbackText =
        'There are currently no results to display at this time. Please check back soon'

    useEffect(() => {
        const iframePostWidthData = {
            iframeRef: scheduleIframe,
            containerRef: widgetWrap,
            offset: offset,
        }

        postWidthToIframe(iframePostWidthData)

        function handleResize() {
            postWidthToIframe(iframePostWidthData)
        }

        window.addEventListener('resize', debounce(handleResize, 50))

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <OlympicWidgetWrap isFullSize={isFullSize}>
            {fallbackIsActive ? (
                <FallbackMessage message={fallbackText} />
            ) : (
                <StyledScheduleWrap isFullSize={isFullSize} ref={widgetWrap}>
                    <StyledIframe
                        ref={scheduleIframe}
                        title="widget-iframe"
                        src="/olympic-wdg/schedule"
                    ></StyledIframe>
                </StyledScheduleWrap>
            )}
        </OlympicWidgetWrap>
    )
}
